import gameConfig from "../../../../engines/configs/gameConfig";
import O1HD from "../../../../engines/gameEngine";
import data_control from "../../../../engines/libs/data_control";
import utilsModel from "../../../../engines/libs/utilsModel";
import { backPackEventMap } from "../../config/BackpackEventConfig";
import { normalBackPackSaveI } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import stallManager from "../../manager/stallManager";
import guessFistPage from "./guessFistPage";
import stallItem from "./stallItem";
import stallPeople from "./stallPeople";

const {ccclass, property} = cc._decorator;

@ccclass
export default class stallPrefab extends cc.Component {

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    @property({type:cc.Node,displayName:"peopelLayout"})
    peopleContent:cc.Node = null;

    @property({type:cc.Node,displayName:"卖出按钮Layout"})
    btnLayout:cc.Node = null;

    @property({type:cc.Prefab,displayName:"石头剪刀布预制体"})
    stonePrefab:cc.Prefab = null;

    @property({type:cc.Node,displayName:"吆喝按钮"})
    shoutBtn:cc.Node = null;

    start(){
        this.updatePage();
        this.onPeopleStartMove();
        this.onPeopleBuyOne();
    }

    updatePage(){
        let unlockAry:number[] = NormalGameManager._instance.stallManager.getData().unlockItems;
        this.itemContent.children.forEach((n:cc.Node,index:number)=>{
            let isUnlock:boolean = false;
            if(unlockAry.includes(index)){
                // 是已经解锁了的
                isUnlock = true;
            }
            let ns = n.getComponent(stallItem);
            ns.setIsUnlock(isUnlock,index);
        });
    }
    
    laotouNodePool:cc.NodePool = new cc.NodePool();
    laotaiNodePool:cc.NodePool = new cc.NodePool();

    //创建人的时间
    peopleBuyInitIntervalTime:number = 8;

    peopleBuyIntervalTime:number = 8;

    @property({type:cc.Node,displayName:"购买东西的人"})
    peopleAry:cc.Node[] = [];

    buyFlag:boolean = false;

    async onPeopleStartMove(){
        for(let i =0;i<this.peopleAry.length;i++){
            await new Promise<void>(resolve=>{
                if( i == 0){
                    let people = this.peopleAry[i];
                    let ps = people.getComponent(stallPeople);
                    ps.onePeopleNoBuyAction();
                    resolve();
                }else{
                    this.scheduleOnce(()=>{
                        let people = this.peopleAry[i];
                        let ps = people.getComponent(stallPeople);
                        ps.onePeopleNoBuyAction();
                        resolve();
                    },2);
                }
            });
        }
    }
    
    lastBuyPeopleId:string = "";

    async onPeopleBuyOne(){
        this.scheduleOnce(this.peopleBuy,this.peopleBuyIntervalTime);
    }

    nowSellBackItem:normalBackPackSaveI = null;
    nowSellAllPrice:number = null;
    nowSellCount:number = null;
    nowSellNode:cc.Node = null;
    nowBuyPeople:cc.Node = null;

    async peopleBuy(){
        let randPeople = this.peopleAry[Math.floor(Math.random() * this.peopleAry.length)];
        while(randPeople.uuid == this.lastBuyPeopleId){
            randPeople = this.peopleAry[Math.floor(Math.random() * this.peopleAry.length)];
        }
        this.lastBuyPeopleId = randPeople.uuid;
        let rs = randPeople.getComponent(stallPeople);
        await rs.onePeopleBuyAction();
        let hasObjItemAry:cc.Node[] = [];
        this.itemContent.children.forEach((n:cc.Node)=>{
            let ns = n.getComponent(stallItem);
            if(ns.backItem){
                hasObjItemAry.push(n);
            }
        });
        let randObjNode:cc.Node = data_control.getRandItemOfArray(hasObjItemAry);
        if(randObjNode){
            // 有东西可以交易
            let ros = randObjNode.getComponent(stallItem);
            let randItem = ros.backItem;
            ros.isSell = true;
            let backConfig = backPackEventMap()[randItem.backId];
            let price = backConfig.sellPrice;
            let minPrice = price * 0.8;
            let maxPrice = price * 1.2;
            let realPrice = Math.floor(data_control.getRandNumberOfArrayTwo([minPrice,maxPrice]));
            let objCount:number = randItem.num;
            let randCount:number = Math.round(data_control.getRandNumberOfArrayTwo([1,objCount]));
            if(this.VipTime > 0){
                randCount = objCount;
            }
            let allPrice:number = randCount * realPrice;
            this.nowSellAllPrice = allPrice;
            this.nowSellCount = randCount;
            this.nowSellBackItem = randItem;
            this.nowSellNode = randObjNode;
            this.nowBuyPeople = randPeople;
            let str = `<color=#000000>${backConfig.name}</c><color=#FF0000>${data_control.getNumberFormat(realPrice)}</c><color=#000000>一个卖我</c><color=#FF0000>${data_control.getNumberFormat(randCount)}</c><color=#FF0000>个</c><color=#000000>一共</c><color=#FF0000>${data_control.getNumberFormat(allPrice)}</c><color=#000000>元</c>`;
            await rs.showChat(str,false);
            this.scheduleOnce(this.peopleAutoMove,this.autoTime);
            this.showBtns();
        }else{
            // 没有东西可以交易
            let str = "<color=#000000>什么东西都没有你还出来摆摊？</c>";
            await rs.showChat(str,true,2);
            rs.onePeopleNoBuyAction();
            this.onPeopleBuyOne();
        }
    }

    /**
     * 加价
    */
    onBtnAddPrice(){
        this.unschedule(this.peopleAutoMove);
        this.isStopTime = true;
        let node:cc.Node = cc.instantiate(this.stonePrefab);
        let ns = node.getComponent(guessFistPage);
        ns.bindCompleteFun((winFlag:number)=>{
            switch(winFlag){
                case 0:{
                    // 加价20%卖
                    console.log("加价20%卖");
                    this.nowSellAllPrice = this.nowSellAllPrice * 1.2;
                    break;
                }
                case 1:{
                    console.log("降价20%卖");
                    this.nowSellAllPrice = this.nowSellAllPrice * 0.8;
                    break;
                }
                case 2:{
                    console.log("不加价卖");
                    break;
                }
            }
            this.onObjSell();
            this.isStopTime = false;
        });
        node.setParent(O1HD.Canvas());
    }

    onObjSell(){
        this.unschedule(this.peopleAutoMove);
        if(this.nowSellNode){
            let ns = this.nowSellNode.getComponent(stallItem);
            ns.isSell = false;
            O1HD.getServices().userSrv.setCoins(this.nowSellAllPrice,true,this.nowSellNode);
            let residueCount:number = this.nowSellBackItem.num - this.nowSellCount;
            if(residueCount <= 0){
                ns.backItem = null;
            }
            NormalGameManager._instance.onOutGoods(this.nowSellBackItem.backId,this.nowSellCount);
            ns.updateItem();

            let ros = this.nowBuyPeople.getComponent(stallPeople);
            ros.hideChat().then(()=>{
                ros.onePeopleNoBuyAction();
            });
            this.onPeopleBuyOne();
        }
        this.initBuyData();
        this.hideBtns();
    }

    /**
     * 卖出
     */
    onBtnSell(){
        this.onObjSell();
    }

    /**
     * 吆喝
     */
    onBtnHorn(){
        if(this.VipTime > 0){
            O1HD.getModules().uiControlModule.showMessageBox("已经在吆喝了");
            return;
        }
        utilsModel.loadAndShowVideoAdTrans(()=>{
            this.startVipTime();
        },()=>{

        },null,"看广告吆喝");
    }

    showBtns(){
        return new Promise<void>(resolve=>{
            this.btnLayout.active = true;
            this.btnLayout.scale = 0;
            cc.tween(this.btnLayout).to(0.2,{scale:1},{easing:cc.easing.backOut}).call(resolve).start();
        });
    }

    hideBtns(){
        return new Promise<void>(resolve=>{
            cc.tween(this.btnLayout).to(0.2,{scale:0},{easing:cc.easing.backIn}).call(resolve).start();
        });
    }

    autoTime:number = 4;

    initBuyData(){
        this.nowSellAllPrice = null;
        this.nowSellNode = null;
        this.nowSellCount = null;
        this.nowBuyPeople = null;
        this.nowSellBackItem = null;
    }

    async peopleAutoMove(){
        if(this.nowBuyPeople){
            let node = this.nowBuyPeople;
            let ns = node.getComponent(stallPeople);
            this.hideBtns();
            await ns.hideChat();
            ns.onePeopleNoBuyAction();
            this.initBuyData();
            this.onPeopleBuyOne();
        }

    }

    VipTime:number = 0;

    isStopTime:boolean = false;

    jiaomaiSoundId:number = null;

    startVipTime(){
        this.isStopTime = false;
        this.VipTime = gameConfig.STALL_VIP_TIME;
        this.peopleBuyIntervalTime = 1;
        this.schedule(this.subVipTime,1);
        this.startVipAni();
        O1HD.getManagers().soundMgr.playSound("jiaomai").then((id:number)=>{
            this.jiaomaiSoundId = id;
        });
        console.log("开始VIP时间");
    }

    subVipTime(){
        if(NormalGameManager._instance.getGameIsPause()){
            return;
        }
        if(this.isStopTime){
            return;
        }
        if(this.VipTime > 0){
            this.VipTime --;
        }else{
            this.unschedule(this.subVipTime);
            this.stopVipAni();
            this.peopleBuyIntervalTime = this.peopleBuyInitIntervalTime;
            O1HD.getManagers().soundMgr.stopSound(this.jiaomaiSoundId);
            console.log("停止VIP时间");
        }
    }

    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.closeThis();
    }

    closeThis(){
        NormalGameManager._instance.backNotSell();
        this.node.destroy();
        this.node.removeFromParent();
    }

    @property({type:cc.Node,displayName:"喇叭动画"})
    laBaAni:cc.Node = null;

    startVipAni(){
        this.laBaAni.active = true;
    }

    stopVipAni(){
        this.laBaAni.active = false;
    }

}
